import styled from 'styled-components'
import { match } from 'ts-pattern'

import { Numeric } from '@blade/ui-kit'

import type { ClassNameProps } from '@root/shared/react'
import type BigNumber from 'bignumber.js'

type ProfilePositionsTableAmountCellProps = {
  amountUsd: BigNumber
  type: 'bought' | 'sold' | 'remaining'
} & ClassNameProps

export const ProfilePositionsTableAmountCell: React.FC<
  ProfilePositionsTableAmountCellProps
> = ({ className, amountUsd, type }) => {
  return (
    <Root className={className}>
      <Amount $type={type}>
        <Numeric
          value={amountUsd}
          preset="currency-amount-short"
          currency={'$'}
        />
      </Amount>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 1px;
`

const Amount = styled.div<{
  $type: ProfilePositionsTableAmountCellProps['type']
}>`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  gap: 2px;

  color: ${({ $type }) =>
    match($type)
      .with('bought', () => 'var(--up-9)')
      .with('sold', () => 'var(--down-9)')
      .with('remaining', () => 'var(--neutral-9)')
      .exhaustive()};
`
